// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"49036f15","963":"7f621882"}[chunkId] + ".chunk.js";
};